import { ExceptionalRecognitionApproverType } from '../enums/exceptional-recognition-approver-type.enum';

// Maps each approver role to its translation key (resolved with the translate pipe at the usage sites).
// Reuses Special Recognitions' chain keys wherever the role label is identical (N-2, Head of Hierarchy) so EXR
// shares SR's translations; the remaining roles have no SR equivalent and use EXR's own approver-selection keys.
const APPROVER_TYPE_TRANSLATE_KEYS: Record<ExceptionalRecognitionApproverType, string> = {
  [ExceptionalRecognitionApproverType.RegionalHrBp]:
    'exceptional-recognitions.proposal-dialog.approver-selection.regional-hr-bp',
  [ExceptionalRecognitionApproverType.GlobalHrBp]:
    'exceptional-recognitions.proposal-dialog.approver-selection.global-hr-bp',
  [ExceptionalRecognitionApproverType.NMinus2]: 'special-payment.task.n-2',
  [ExceptionalRecognitionApproverType.HeadOfHierarchy]: 'special-payment.task.head-of-hierarchy',
  [ExceptionalRecognitionApproverType.CAndB]: 'exceptional-recognitions.proposal-dialog.approver-selection.c-and-b',
  [ExceptionalRecognitionApproverType.HeadOfHR]:
    'exceptional-recognitions.proposal-dialog.approver-selection.head-of-hr',
  [ExceptionalRecognitionApproverType.HeadOfMA]:
    'exceptional-recognitions.proposal-dialog.approver-selection.head-of-ma'
};

export function getApproverTypeTranslateKey(type: ExceptionalRecognitionApproverType): string {
  return APPROVER_TYPE_TRANSLATE_KEYS[type];
}
